import { generateTitle } from 'utils/charts/common';
import {
    noResultsText,
    PERCENT_OF_EXECUTION_ONLY_TRADES
} from 'utils/charts/constants';
import { EO_TRADES_TITLE } from 'utils/charts/constants';

export const scenarioThreeVcDataChartOptions = (data) => {
    return {
        title: generateTitle(EO_TRADES_TITLE),
        xAxis: {
            type: 'category',
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            data: data ? ['Non-VC', 'VC'] : [],
            name: 'VC Status',
            nameLocation: 'center',
            nameTextStyle: {
                padding: [20, 0, 0, 0],
                color: '#7FADBF',
                fontWeight: 600,
                fontSize: 12
            },
            nameGap: 30,
            splitLine: {
                show: false
            }
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                show: false
            },
            name: PERCENT_OF_EXECUTION_ONLY_TRADES,
            nameLocation: 'center',
            nameGap: 60,
            nameTextStyle: {
                padding: [20, 0, 0, 0],
                color: '#8DA8B3',
                fontWeight: 'bold'
            },
            splitLine: {
                show: false
            }
        },
        series: [
            {
                barWidth: '50%',
                barGap: '4px',
                barCategoryGap: '4px',
                data: [
                    {
                        value: data && data.eoNonVc.toFixed(2),
                        itemStyle: {
                            color: '#8FDDC2'
                        },
                        label: data && {
                            show: true,
                            formatter: '{c}%',
                            position: 'insideTop',
                            distance: -20,
                            color: '#929292'
                        }
                    },
                    {
                        value: data && data.eoVc.toFixed(2),
                        itemStyle: {
                            color: '#FF90A2'
                        },
                        label: data && {
                            show: true,
                            formatter: '{c}%',
                            position: 'insideTop',
                            distance: -20,
                            color: '#929292'
                        }
                    }
                ],
                type: 'bar',
                colorBy: 'data',
                cursor: 'default'
            }
        ],
        labelLine: {
            show: false
        },
        grid: {
            width: '400px',
            left: '15%'
        },
        graphic: data ? [] : [noResultsText]
    };
};
